const DEFAULT_DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: "medium",
  timeStyle: "short",
}

type FormatAgentRunElapsedOptions = {
  now?: number
  useCurrentTimeForMissingEnd?: boolean
}

export function parseAgentRunTime(iso: string | null | undefined): number | null {
  if (!iso) return null
  const time = Date.parse(iso)
  return Number.isFinite(time) ? time : null
}

export function formatAgentRunElapsed(
  startedAt: string | null | undefined,
  endedAt: string | null | undefined,
  { now = Date.now(), useCurrentTimeForMissingEnd = true }: FormatAgentRunElapsedOptions = {}
): string {
  const start = parseAgentRunTime(startedAt)
  if (start === null) return "—"

  const end = parseAgentRunTime(endedAt)
  if (end === null && !useCurrentTimeForMissingEnd) return "—"

  const effectiveEnd = end ?? now
  const seconds = Math.max(0, Math.round((effectiveEnd - start) / 1000))
  if (seconds < 60) return `${seconds}s`

  const mins = Math.floor(seconds / 60)
  const remainingSeconds = seconds - mins * 60
  if (remainingSeconds === 0) return `${mins}m`

  return `${mins}m ${remainingSeconds}s`
}

export function formatAgentRunDateTime(
  iso: string | null | undefined,
  locale?: string,
  options?: Intl.DateTimeFormatOptions
): string | null {
  const time = parseAgentRunTime(iso)
  if (time === null) return null

  return new Intl.DateTimeFormat(locale, {
    ...DEFAULT_DATE_TIME_FORMAT_OPTIONS,
    ...options,
  }).format(new Date(time))
}
